<template>
  <section
    class="trending-section padding-bottom pt-30"
    id="lotesdestaque"
    v-if="getLotesMaisVisualizados.data && getLotesMaisVisualizados.data.length > 0"
  >
    <div class="container">
      <div class="section-header-3">
        <div class="left d-block">
          <h2 class="title mb-3">Destaques</h2>
          <p>Veja os lotes com mais lances</p>
        </div>
      </div>
      <div class="row mb-30-none justify-content-center" v-if="!getLotesMaisVisualizadosLoading">
        <lote-card-vertical v-for="lote in getLotesMaisVisualizados.data" :key="lote.loteId" :lote="lote" classeRaiz="col-lg-6 col-md-12 col-sm-12" />
      </div>
      <div class="row justify-content-center mb-30-none" v-if="getLotesMaisVisualizadosLoading">
        <lote-card-loader />
        <lote-card-loader />
        <lote-card-loader />
        <lote-card-loader />
      </div>
    </div>
  </section>
</template>

<script>
import LoteCardVertical from '@/components/LoteCardVertical.vue';
import LoteCardLoader from '@/components/LoteCardLoader.vue';
import { mapActions, mapGetters } from 'vuex';
export default {
  props: {
    lotesDestaque: {
      type: Array,
    },
  },
  components: {
    LoteCardLoader,
    LoteCardVertical,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['getLotesMaisVisualizados', 'getLotesMaisVisualizadosLoading']),
  },
  methods: {
    ...mapActions(['setLotesMaisVisualizados']),
  },
  async mounted() {
    await this.setLotesMaisVisualizados();
  },
};
</script>

<style></style>
